import React, { useCallback, useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-grid-system";

import { store } from "react-notifications-component";

import api from "../../services/api";

import { Loading } from "../../components/loading";
import Input from "../../components/input/input_v2";
import Button from "../../components/button/button_v2";
import Modal from "../../components/modal/modalGeneric";
import GenericUpper from "../../components/generic-upper";
import TableWithLabelBlackV2 from '../../components/TableWithLabelBlack/indexV2';
import HomologButtonHistory from "../../components/historico/homologButtonHistory";

import ArrowDown from "../../assets/icons/icon-arrow-down.svg";
import status0 from "../../assets/icons/icon-status-nao-enviado.png";
import status2 from "../../assets/icons/icon-status-pending.png";
import status3 from "../../assets/icons/icon-status-enviado.svg";
import iconCopy from "../../assets/icons/icons8-copiar-32-branco.png";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import * as S from "./styles";
import { theme } from "../../styles/theme";
import { H5, TaglineP } from "../../styles/stylesTypography";
const FILTER_FIELD_MAP = {
  nf: "nf",
  serie: "serie",
  cliente: "razao_social_cliente",
  cpf_cnpj_cliente: "cpf_cnpj_cliente",
  municipio_cliente: "municipio_cliente",
  data_emissao: "data_emissao",
  status: "status_envio",
  produtos: "produtos",
};

const normalizeFilterValue = (value) => String(value ?? "").trim();
const isEmptyMode = (mode) => mode === "isEmpty" || mode === "isNotEmpty";

const mapMatchModeToApi = (matchMode) => matchMode;

const buildConstraint = (matchMode, value) => {
  const normalizedValue = normalizeFilterValue(value);
  if (!isEmptyMode(matchMode) && !normalizedValue) return null;
  return {
    matchMode: mapMatchModeToApi(matchMode),
    value: normalizedValue,
  };
};

const buildApiFiltersPayload = (columnFilters = {}) => {
  return Object.entries(columnFilters).reduce((acc, [columnKey, state]) => {
    const apiField = FILTER_FIELD_MAP[columnKey];
    if (!apiField || !state) return acc;

    if (columnKey === "status") {
      const selectedValues = Array.isArray(state.selectedValues)
        ? state.selectedValues.map((value) => normalizeFilterValue(value)).filter(Boolean)
        : [];
      if (selectedValues.length === 0) return acc;

      acc[apiField] = {
        operator: selectedValues.length > 1 ? "or" : "and",
        constraints: selectedValues.map((value) => ({
          matchMode: "contains",
          value,
        })),
      };
      return acc;
    }

    const constraints = [];
    const sharedValueForEmptyMode = isEmptyMode(state.mode)
      ? (state.secondaryValue ?? state.value)
      : state.value;
    const primaryConstraint = buildConstraint(state.mode, sharedValueForEmptyMode);
    if (primaryConstraint) constraints.push(primaryConstraint);

    const secondaryConstraint = buildConstraint(state.secondaryMode, state.secondaryValue);
    if (secondaryConstraint) constraints.push(secondaryConstraint);

    if (constraints.length === 0) return acc;

    acc[apiField] = {
      operator: state.combine === "or" ? "or" : "and",
      constraints,
    };
    return acc;
  }, {});
};

const parseJsonValue = (value) => {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch (_) {
    return value;
  }
};

const getRequestPayloadFromRow = (row) => {
  const payloads = row?.agro_prescriptions_payloads;
  if (!Array.isArray(payloads) || payloads.length === 0) return null;

  const firstPayload = payloads[0];
  return firstPayload?.payload != null
    ? parseJsonValue(firstPayload.payload)
    : parseJsonValue(firstPayload);
};

const getNfStatusProps = (statusEnvio) => {
  const key = String(statusEnvio ?? "").trim().toLowerCase();
  switch (key) {
    case "enviado":   return { homologado: 1, statusEnvio: 3 };
    case "pendente":  return { homologado: 2, statusEnvio: 2 };
    case "erro":
    case "cancelado":
    default:          return { homologado: 0, statusEnvio: 4 };
  }
};

const ExportarDefesasNfDetails = (props) => {
  const { match, history } = props;
  const { uf } = match.params;

  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limit, setLimit] = useState(30);
  const [total, setTotal] = useState(0);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [columnFilters, setColumnFilters] = useState({});
  const [visibleRowsCount, setVisibleRowsCount] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [showPayloadModal, setShowPayloadModal] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState(null);
  const lastFilterPayloadKeyRef = useRef("");
  const inFlightRequestsRef = useRef(0);

  const fetchInvoices = async (currentLimit = limit, options = {}) => {
    const { showLoader = true } = options;
    if (showLoader) setLoading(true);
    inFlightRequestsRef.current += 1;
    setTableLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("@userinfo"));
      const subsidiaryId = user?.agro_subsidiary_id;

      if (subsidiaryId && uf) {
        const response = await api.post(
          `/relatorios/homologados/nf/${subsidiaryId}/${uf}?limit=${currentLimit}&offset=0`,
          {
            data_inicio: dataInicio || null,
            data_fim: dataFim || null,
            filters: buildApiFiltersPayload(columnFilters),
          }
        );
        const data = response?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        const normalizedData = Array.isArray(data) ? data : [];
        setInvoices(normalizedData);
        setVisibleRowsCount(normalizedData.length);
        setTotal(totalCount);
      }
    } catch (error) {
      console.error("Erro ao buscar NFs", error);
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-658 Erro ao buscar NFs - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      inFlightRequestsRef.current = Math.max(0, inFlightRequestsRef.current - 1);
      if (inFlightRequestsRef.current === 0) {
        setTableLoading(false);
      }
      if (showLoader) setLoading(false);
    }
  };

  const handleShowMore = () => {
    const newLimit = limit + 30;
    setLimit(newLimit);
    fetchInvoices(newLimit, { showLoader: true });
  };

  const handleColumnFiltersChange = useCallback((nextFilters) => {
    setColumnFilters((previousFilters) => {
      const previousKey = JSON.stringify(previousFilters ?? {});
      const nextKey = JSON.stringify(nextFilters ?? {});
      return previousKey === nextKey ? previousFilters : (nextFilters ?? {});
    });
  }, []);

  useEffect(() => {
    fetchInvoices(limit, { showLoader: true });
  }, [uf]);

  useEffect(() => {
    const filtersPayload = buildApiFiltersPayload(columnFilters);
    const payloadKey = JSON.stringify(filtersPayload);
    const previousPayloadKey = lastFilterPayloadKeyRef.current;
    if (payloadKey === previousPayloadKey) return undefined;

    const hasActiveFiltersNow = Object.keys(filtersPayload).length > 0;
    const hadActiveFiltersBefore = previousPayloadKey !== "" && previousPayloadKey !== "{}";
    lastFilterPayloadKeyRef.current = payloadKey;
    if (!hasActiveFiltersNow && !hadActiveFiltersBefore) return undefined;

    const timer = setTimeout(() => {
      setLimit(30);
      fetchInvoices(30, { showLoader: false });
    }, 2000);

    return () => clearTimeout(timer);
  }, [columnFilters]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleOpenPayloadModal = (row) => {
    const payload = getRequestPayloadFromRow(row);
    setSelectedPayload(payload);
    setShowPayloadModal(true);
  };

  const handleNfHomologar = async (nfId) => {
    try {
      const response = await api.post(`/homologar/nf/${nfId}`);
      store.addNotification({
        title: "Sucesso!",
        message: response?.data?.message || "NF enviada novamente com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      fetchInvoices(limit, { showLoader: false });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: error?.response?.data?.errors || "Erro ao reenviar a NF.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      throw error;
    }
  };

  const copyPayloadJson = async () => {
    if (selectedPayload == null) return;

    try {
      await navigator.clipboard.writeText(JSON.stringify(selectedPayload, null, 2));
      store.addNotification({
        title: "Sucesso!",
        message: "JSON copiado com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 3000, onScreen: true },
      });
    } catch (_) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(_, "ERRO-659 Não foi possível copiar o JSON - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const columns = [
    {
      label: "Status",
      key: "status",
      width: "150px",
      minWidth: "120px",
      enableHorizontalScroll: true,
      justifyContent: "flex-start",
      filterType: "checkbox",
      filterOptions: [
        {
          label: "Enviado",
          value: "enviado",
          color: `${theme.colors.green.Folha}`,
          backgroundColor: "#2FBB6914",
          icon: status3,
        },
        {
          label: "Pendente",
          value: "pendente",
          color: `${theme.colors.yellow.Gema}`,
          backgroundColor: "#F8C84B1F",
          icon: status2,
        },
        {
          label: "Erro",
          value: "erro",
          color: `${theme.colors.red.Tostado}`,
          backgroundColor: "#FF525214",
          icon: status0,
        },
      ],
      enableFilter: false,
      render: (row) => {
        const statusStr = String(row?.status_envio ?? "").trim().toLowerCase();
        const { homologado, statusEnvio: statusEnvioInt } = getNfStatusProps(statusStr);
        const isPendente = statusStr === "pendente";
        return (
          <HomologButtonHistory
            style={{ width: "auto" }}
            estado={uf}
            receitaId={row?.id}
            homologado={homologado}
            statusEnvio={statusEnvioInt}
            updateReceitas={() => fetchInvoices(limit, { showLoader: false })}
            propsLocation={props}
            dataReceita={row}
            onNfHomologar={isPendente ? () => handleNfHomologar(row?.id) : undefined}
          />
        );
      },
    },
    {
      label: "Nº NF",
      key: "nf",
      minWidth: "120px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row?.nf || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Série",
      key: "serie",
      minWidth: "100px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row?.serie || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Data Emissão",
      key: "data_emissao",
      minWidth: "130px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {formatDate(row?.data_emissao)}
        </TaglineP>
      ),
    },
    {
      label: "Cliente",
      key: "cliente",
      width: "100%",
      minWidth: "180px",
      maxWidth: "260px",
      enableFilter: false,
      enableHorizontalScroll: true,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row?.razao_social_cliente || "-"}
        </TaglineP>
      ),
    },
    {
      label: "CPF/CNPJ",
      key: "cpf_cnpj_cliente",
      minWidth: "150px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row?.cpf_cnpj_cliente || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Município/UF",
      key: "municipio_cliente",
      minWidth: "160px",
      enableFilter: false,
      render: (row) => {
        const municipio = row?.municipio_cliente || "-";
        const ufCliente = row?.uf_cliente ? `/${row.uf_cliente}` : "";
        return (
          <TaglineP color={theme.colors.gray.Cinza_1}>
            {`${municipio}${ufCliente}`}
          </TaglineP>
        );
      },
    },
    {
      label: "Natureza Operação",
      key: "natureza_operacao",
      minWidth: "180px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row?.natureza_operacao || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Produtos",
      key: "produtos",
      minWidth: "200px",
      enableFilter: false,
      render: (row) => {
        const items = row?.agro_prescription_invoice_items || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {items.length > 0 ? (
              items.map((item, idx) => {
                const qtd = item?.qtd_produto;
                const un = item?.unidade_medida;
                const qtdLabel =
                  qtd != null && qtd !== ""
                    ? un
                      ? ` (${qtd} ${un})`
                      : ` (${qtd})`
                    : "";
                return (
                  <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                    {`${item?.nome_produto || "-"}${qtdLabel}`}
                  </TaglineP>
                );
              })
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "DADOS DE ENVIO",
      key: "dados_envio",
      minWidth: "150px",
      enableFilter: false,
      render: (row) => {
        const hasPayload = !!getRequestPayloadFromRow(row);
        if (!hasPayload) {
          return <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>;
        }

        return (
          <S.ViewPayloadButton type="button" onClick={() => handleOpenPayloadModal(row)}>
            VER JSON
          </S.ViewPayloadButton>
        );
      },
    },
  ];

  return (
    <>
      <GenericUpper
        title={`Exportar Defesas NF - ${uf}`}
        backLink="/exportar-defesas"
      />

      <S.Wrapper>
        <S.ContainerInputsAndFilter>
            <Input
              id="dataInicio"
              type="date"
              name="dataInicio"
              label="Data Início"
              value={dataInicio}
              onChange={(value) => setDataInicio(value)}
              required={false}
              minHeight="auto"
              marginBottom="0"
            />

            <Input
              id="dataFim"
              type="date"
              name="dataFim"
              label="Data Fim"
              value={dataFim}
              onChange={(value) => setDataFim(value)}
              required={false}
              minHeight="auto"
              marginBottom="0"
            />

            <Button
              id="filtrar"
              name="filtrar"
              value="Filtrar"
              width="120px"
              height="48px"
              onClick={() => fetchInvoices()}
            />
        </S.ContainerInputsAndFilter>

        {loading && invoices.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <Loading size="64px" />
          </div>
        ) : (
          <>
              <TableWithLabelBlackV2
                columns={columns}
                data={invoices}
                showAll={true}
                itemsPerPage={100}
                serverSide={true}
                enableColumnFilters={true}
                useServerSideColumnFilters={true}
                isLoading={tableLoading}
                emptyMessage="Não há NFs para os filtros aplicados"
                onColumnFiltersChange={handleColumnFiltersChange}
                onCountChange={(_, visibleCount) => setVisibleRowsCount(visibleCount)}
              />

            {invoices.length < total && (
              <S.ButtonShowAll onClick={handleShowMore}>
                <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                  Ver mais
                </TaglineP>

                <img
                  src={ArrowDown}
                  alt="Ícone de flecha direcionada para baixo"
                />
              </S.ButtonShowAll>
            )}
          </>
        )}
      </S.Wrapper>

      {showPayloadModal && (
        <Modal
          show={showPayloadModal}
          onHide={() => setShowPayloadModal(false)}
          width="900px"
          responsive
        >
          <H5 color={theme.colors.gray.Cinza_2} fontWeight={700}>
            JSON da requisição
          </H5>

          <S.PayloadFrame>
            <S.PayloadCopyRow onClick={copyPayloadJson}>
              <img src={iconCopy} alt="Copiar código" />
            </S.PayloadCopyRow>

            <S.PayloadPre>
              {selectedPayload != null
                ? JSON.stringify(selectedPayload, null, 2)
                : "Sem dados de envio para esta NF."}
            </S.PayloadPre>
          </S.PayloadFrame>
        </Modal>
      )}
    </>
  );
};

export default withRouter(ExportarDefesasNfDetails);
